var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class completeTheLook extends HTMLElement {
  constructor() {
    super();
    this.featured_image = '';
    this.handleVariantSwitch();
  }

  handleVariantSwitch() {
    this.item = this.querySelector('[ctl-product]');
    if (!this.item) return;
    const selectEl = this.item.querySelector('[data-product-select]');
    if (!selectEl) return;
    const variantJson = this.item.querySelector('[data-variant-json]');
    if (!variantJson) return;

    const variantObject = JSON.parse(variantJson.innerHTML);

    selectEl.addEventListener('change', (e) => {
      const addButton = this.querySelector('[name="add"]');
      if (addButton && addButton.classList.contains('select_option_first'))
        addButton.classList.remove('select_option_first');

      const variantId = selectEl.value;
      const selectedVariant = variantObject.filter((variant) => variant.id == variantId);
      const variant = selectedVariant[0];

      this.updateVariantId(variant);
      this.updateItemPrice(variant);
      this.updateImage(variant);
    });
  }

  updateVariantId(variant) {
    // update input price
    const input = this.item.querySelector('[name="id"]');
    if (input) input.value = variant.id;
  }

  updateItemPrice(variant) {
    // update input price
    let itemUIComparePrice;

    // update UI price
    const itemUIPrice = Shopify.formatMoney(variant.price, window.theme.moneyFormat);
    const UIPriceEl = this.item.querySelector('[data-el-price]');
    if (UIPriceEl) UIPriceEl.innerHTML = itemUIPrice;

    // update UI compare price
    const UIComparePriceEl = this.item.querySelector('[data-el-compare-price]');
    if (UIComparePriceEl) {
      if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        itemUIComparePrice = Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat);
        UIComparePriceEl.innerHTML = `<del>${itemUIComparePrice}</del>`;
      } else UIComparePriceEl.innerHTML = null;
    }
  }

  updateImage(variant, item) {
    const featured_media = variant.featured_image;
    if (featured_media == null) return;

    if (featured_media.src == this.featured_image) return;

    this.featured_image = featured_media;

    const featuredImageEl = document.createElement('img');
    featuredImageEl.src = featured_media.src;
    featuredImageEl.alt = featured_media.alt ? featured_media.alt : '';

    const UIImageEl = this.item.querySelector('[data-el-media]');
    if (!UIImageEl) return;
    featuredImageEl.addEventListener('load', () => {
      UIImageEl.innerHTML = '';
      UIImageEl.appendChild(featuredImageEl);
    });
  }
}

customElements.define('completethe-look', completeTheLook);